import React from 'react';
import styled from 'styled-components';
import { Grid, Divider } from '@mui/material';
import { type AdditionalDocFormProps } from './types';
import { LabelValue, DocumentBox } from '../../../../../components';
import { APPLICATION_TEXT } from '../../lang';

const ADDITIONAL_DOCUMENTS = APPLICATION_TEXT.ADDITIONAL_DOCUMENTS;
export const AdditionalDocumentForm: React.FunctionComponent<
  AdditionalDocFormProps
> = (props: AdditionalDocFormProps) => {
  const { documentType, supportingDocuments } = props.data ?? [];

  const hasFiles = supportingDocuments.length > 0;

  return (
    <Container>
      <Grid size={12}>
        <LabelValue label={ADDITIONAL_DOCUMENTS.CAPTION} value={documentType} />
        <Divider />
      </Grid>
      <div className="supporting-documents">
        <h3>{APPLICATION_TEXT.SUPPORTING_DOCUMENT}</h3>
        <div className="document-display">
          {hasFiles ? (
            supportingDocuments.map((supportingDocument, index) => {
              return <DocumentBox key={index} file={supportingDocument} />;
            })
          ) : (
            <div>
              <p>{APPLICATION_TEXT.NA}</p>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .supporting-documents {
    padding: 0.5rem 0 0 1rem;

    .document-display {
      padding: 0.5rem 1rem;
    }

    h3 {
      font-style: italic;
      color: #8c8c8c;
    }
  }

  .MuiBox-root {
    padding: 0 0 0.1rem 0.5rem;
  }

  .MuiGrid-item {
    padding-left: 0 !important;
  }
`;
